import api from "../../index.js";

export const GetWalletApi = (userId, params) => api.get(`WalletMaster/Get-WalletDetailsByRule/${userId}?${params}`);
export const GetPaymentGatewayApi = () => api.get('PaymentGateway/GetActivePaymentGatways');
export const DepositAmountApi = (data, headers) => api.post('WalletMaster/Create-Deposit-Request', data, headers);
export const GetPaymentGatewayByIdApi = (params) => api.get(`BankDetails/Get-Active-Bank-Details`);
export const getBankDataApi = () => api.get(`BankDetails/Get-Active-Bank-Details`);
export const GetAllDepositRequestApi = (params) => api.get(`WalletMaster/Get-All-Deposit-Request?${params}`);
export const GetCurrentCurrencyRateApi = () => api.get(`Currency/Get-Current-Currency-Rate`);